/* ============================================================================
   mg-tarrit-theme.js
   ----------------------------------------------------------------------------
   Global behaviour shared by all mg_ sections/snippets:
   - light/dark theme toggle
   - sticky header scroll state
   - mega menu (desktop) + mobile nav drawer
   - cart drawer wired to Shopify's real Ajax Cart API (/cart/add.js, /cart.js,
     /cart/change.js) -- NOT a fake in-memory cart, so it works with discounts,
     variants, and checkout out of the box.
   - scroll-reveal for [data-mg-reveal] / [data-mg-stagger]

   INSTALL: upload as Assets/mg-tarrit-theme.js and add before </body> in
   layout/theme.liquid:
     <script src="{{ 'mg-tarrit-theme.js' | asset_url }}" defer></script>
   ========================================================================= */
(function () {
  "use strict";
  var rm = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var root = document.documentElement;

  /* ---------- theme toggle ---------- */
  var themeBtn = document.getElementById("mg_themeBtn");
  if (themeBtn) {
    var saved = null;
    try { saved = localStorage.getItem("mg_theme"); } catch (e) {}
    if (saved) root.setAttribute("data-mg-theme", saved);
    themeBtn.setAttribute("aria-pressed", String(root.getAttribute("data-mg-theme") === "dark"));
    themeBtn.addEventListener("click", function () {
      var dark = root.getAttribute("data-mg-theme") === "dark";
      var next = dark ? "light" : "dark";
      root.setAttribute("data-mg-theme", next);
      themeBtn.setAttribute("aria-pressed", String(!dark));
      try { localStorage.setItem("mg_theme", next); } catch (e) {}
    });
  }

  /* ---------- sticky header scroll state ---------- */
  var header = document.getElementById("mg_header");
  if (header) {
    var onScroll = function () { header.classList.toggle("mg_is-scrolled", window.scrollY > 40); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mega menu ---------- */
  var megaOpen = false;
  function setMega(trigger, mega, state) {
    megaOpen = state;
    mega.classList.toggle("mg_is-open", state);
    trigger.setAttribute("aria-expanded", state);
  }
  document.querySelectorAll("[data-mg-mega-trigger]").forEach(function (trigger) {
    var mega = document.getElementById(trigger.getAttribute("aria-controls"));
    if (!mega) return;
    trigger.addEventListener("mouseover", function (e) {
      e.stopPropagation();
      setMega(trigger, mega, !megaOpen);
    });
    if (header) header.addEventListener("mouseleave", function () { setMega(trigger, mega, false); });
    document.addEventListener("click", function (e) {
      if (megaOpen && !mega.contains(e.target) && e.target !== trigger) setMega(trigger, mega, false);
    });
  });

  /* ---------- mobile nav ---------- */
  var mnav = document.getElementById("mg_mnav");
  var scrim = document.getElementById("mg_scrim");
  var drawer = document.getElementById("mg_drawer");
  function openMnav() {
    if (!mnav || !scrim) return;
    mnav.classList.add("mg_is-on"); scrim.classList.add("mg_is-on");
    mnav.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden";
  }
  function closeMnav() {
    if (!mnav || !scrim) return;
    mnav.classList.remove("mg_is-on");
    if (!drawer || !drawer.classList.contains("mg_is-on")) scrim.classList.remove("mg_is-on");
    mnav.setAttribute("aria-hidden", "true"); document.body.style.overflow = "";
  }
  var burger = document.getElementById("mg_burger");
  var mnavClose = document.getElementById("mg_mnavClose");
  if (burger) burger.addEventListener("click", openMnav);
  if (mnavClose) mnavClose.addEventListener("click", closeMnav);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeMnav(); closeCart(); }
  });

  /* ---------- cart drawer (real Shopify Ajax Cart API) ---------- */
  var cartBody = document.getElementById("mg_cartBody");
  var cartFoot = document.getElementById("mg_cartFoot");
  var cartSub = document.getElementById("mg_cartSub");
  var cartCountEls = document.querySelectorAll("[data-mg-cart-count]");

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.mgMoneyFormat) {
      return Shopify.formatMoney(cents, window.mgMoneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function openCart() {
    if (!drawer || !scrim) return;
    drawer.classList.add("mg_is-on"); scrim.classList.add("mg_is-on");
    drawer.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!drawer || !scrim) return;
    drawer.classList.remove("mg_is-on");
    if (!mnav || !mnav.classList.contains("mg_is-on")) scrim.classList.remove("mg_is-on");
    drawer.setAttribute("aria-hidden", "true"); document.body.style.overflow = "";
  }

  function renderCart(cart) {
    if (!cartBody) return;
    cartCountEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle("mg_is-on", cart.item_count > 0);
    });
    if (!cart.item_count) {
      cartBody.innerHTML =
        '<div class="mg_cart-empty"><p>Your cart is empty.</p>' +
        '<a class="mg_btn mg_btn--outline" href="/collections/all">Keep shopping</a></div>';
      if (cartFoot) cartFoot.style.display = "none";
      return;
    }
    var html = "";
    cart.items.forEach(function (item, idx) {
      html +=
        '<div class="mg_citem">' +
          '<img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, "_128x160$1$2") : "") + '" alt="' + item.product_title + '" loading="lazy">' +
          '<div>' +
            '<div class="mg_ci-name">' + item.product_title + '</div>' +
            '<div class="mg_ci-meta">' + (item.variant_title ? item.variant_title : "") + "</div>" +
            '<div class="mg_qty">' +
              '<button type="button" data-mg-cart-action="decrease" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-mg-cart-action="increase" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div>' +
            '<div class="mg_ci-price">' + money(item.final_line_price) + '</div>' +
            '<button type="button" class="mg_rm" data-mg-cart-action="remove" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>';
    });
    cartBody.innerHTML = html;
    if (cartSub) cartSub.textContent = money(cart.total_price);
    if (cartFoot) cartFoot.style.display = "block";
  }

  function fetchCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return fetchCart();
      })
      .then(openCart)
      .catch(function (err) {
        console.error("mg_tarrit: add to cart failed", err);
        alert((err && err.description) || "Could not add this item to your cart.");
      });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener("click", function (e) {
    var addBtn = e.target.closest("[data-mg-add-to-cart]");
    if (addBtn) {
      var variantId = addBtn.getAttribute("data-mg-add-to-cart");
      if (!variantId) return;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = "Adding\u2026";
      addToCart(variantId, 1).then(function () {
        addBtn.disabled = false;
        addBtn.textContent = original;
      });
      return;
    }
    var cartAction = e.target.closest("[data-mg-cart-action]");
    if (cartAction) {
      var action = cartAction.getAttribute("data-mg-cart-action");
      var key = cartAction.getAttribute("data-key");
      if (action === "remove") { changeLine(key, 0); }
      else { changeLine(key, cartAction.getAttribute("data-qty")); }
      return;
    }
    if (e.target.closest("[data-mg-cart-open]")) { openCart(); }
    if (e.target.closest("[data-mg-cart-close]")) { closeCart(); }
  });
  if (scrim) scrim.addEventListener("click", function () { closeCart(); closeMnav(); });
  if (cartBody || cartCountEls.length) fetchCart();

  /* ---------- newsletter (uses Shopify's native customer form, no JS required
     for submission -- this only adds the inline confirmation state) ---------- */
  document.querySelectorAll("[data-mg-newsletter-form]").forEach(function (form) {
    var doneEl = form.parentElement.querySelector("[data-mg-newsletter-done]");
    if (window.location.search.indexOf("customer_posted=true") > -1 && doneEl) {
      form.style.display = "none";
      doneEl.textContent = "You are in. Welcome to the family.";
    }
  });

  /* ---------- shop-by-colour "more colours" toggle ---------- */
  document.querySelectorAll("[data-mg-colour-more]").forEach(function (btn) {
    var grid = document.getElementById(btn.getAttribute("data-mg-colour-more"));
    if (!grid) return;
    var expanded = false;
    btn.addEventListener("click", function () {
      expanded = !expanded;
      grid.classList.toggle("mg_show-all", expanded);
      btn.textContent = expanded ? "Fewer colours" : "More colours";
    });
  });

  /* ---------- reveal on scroll ---------- */
  if (!rm && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("mg_is-in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".mg_reveal, .mg_stagger, .mg_footmark").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".mg_reveal, .mg_stagger, .mg_footmark").forEach(function (el) { el.classList.add("mg_is-in"); });
  }
})();